module.exports = __webpack_public_path__ + "static/busDirections-786576dd550064f363b0ed5f7e8558a9.gif";